export enum IntegrationsActionType {
  SET_DATA = 'SET_DATA',
  SET_VIEW = 'SET_VIEW',
}
